module.exports = __webpack_public_path__ + "img/bs.11a4e225.svg";